export const size = {
    font_size_a: 30,
    font_size_b: 25,
    font_size_c: 20,
    font_size_d: 18,
    font_size_e: 14,
    font_size_f: 12,
    changeSize: (size: number) => size / 3.5,
}   